var map = {
	"./cert/en.yml": 527,
	"./email/en.yml": 247,
	"./en.yml": 652,
	"./feedback/en.yml": 370,
	"./frontpage/en.yml": 319,
	"./groups/en.yml": 13,
	"./models/en.yml": 855,
	"./teacher/en.yml": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;